module.exports = __webpack_public_path__ + "static/media/PORKYS_-01.8ca25663.svg";